export default __webpack_public_path__ + "0513714.png";